/**
 * Boards of area (e) — finance. OWNED BY area (e) — finance (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const financeBoards: BoardDef[] = [
  {
    id: "AF-Vue",
    ref: "AF1",
    title: "Finance — vue d'ensemble",
    area: "finance",
    path: "/finance",
    href: "/finance",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.vue",
    space: null,
    component: lazy(() => import("./boards/AF-Vue")),
  },
  {
    id: "AF-Paiements",
    ref: "AF2",
    title: "Paiements création & annonce légale",
    area: "finance",
    path: "/finance/paiements",
    href: "/finance/paiements",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.paiements",
    space: null,
    component: lazy(() => import("./boards/AF-Paiements")),
  },
  {
    id: "AF-Bloques",
    ref: "AF3",
    title: "Paiements bloqués depuis plus de 6 h",
    area: "finance",
    path: "/finance/paiements/bloques",
    href: "/finance/paiements/bloques",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.paiements",
    space: null,
    component: lazy(() => import("./boards/AF-Bloques")),
  },
  {
    id: "AF-Remboursements",
    ref: "AF4",
    title: "Remboursements à émettre",
    area: "finance",
    path: "/finance/remboursements",
    href: "/finance/remboursements",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.remboursements",
    space: null,
    component: lazy(() => import("./boards/AF-Remboursements")),
  },
  {
    id: "AF-Dossier-Paiement",
    ref: "AF5",
    title: "Dossier — onglet Paiement & remboursement",
    area: "finance",
    path: "/finance/paiements/$dossierId",
    href: "/finance/paiements/dos_atelier_nord",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "drawer",
    nav: "finance.paiements",
    space: null,
    note: "Tiroir dossier de 780 px, onglet « Paiement & remboursement », sur Paiements.",
    component: lazy(() => import("./boards/AF-Dossier-Paiement")),
  },
  {
    id: "AF-Remboursements-AE",
    ref: "AF6",
    title: "Remboursements auto-entrepreneur (ancien parcours)",
    area: "finance",
    path: "/finance/remboursements/auto-entrepreneurs",
    href: "/finance/remboursements/auto-entrepreneurs",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.remboursements",
    space: null,
    component: lazy(() => import("./boards/AF-Remboursements-AE")),
  },
  {
    id: "AF-Rapprochement",
    ref: "AF7",
    title: "Rapprochement Stancer",
    area: "finance",
    path: "/finance/rapprochement",
    href: "/finance/rapprochement",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.rapprochement",
    space: null,
    component: lazy(() => import("./boards/AF-Rapprochement")),
  },
  {
    id: "AF-Abonnements",
    ref: "AF8",
    title: "Abonnements clients",
    area: "finance",
    path: "/finance/abonnements",
    href: "/finance/abonnements",
    permission: ["finance.admin", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.abonnements",
    space: null,
    component: lazy(() => import("./boards/AF-Abonnements")),
  },
  {
    id: "AF-Compta-Mensuelle",
    ref: "AF9",
    title: "Facturation de la comptabilité mensuelle",
    area: "finance",
    path: "/finance/compta-mensuelle",
    href: "/finance/compta-mensuelle",
    permission: ["finance.admin", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.compta-mensuelle",
    space: null,
    component: lazy(() => import("./boards/AF-Compta-Mensuelle")),
  },
  {
    id: "AF-Grilles",
    ref: "AF10",
    title: "Grilles tarifaires",
    area: "finance",
    path: "/finance/grilles",
    href: "/finance/grilles",
    permission: ["finance.admin", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.grilles",
    space: null,
    note: "Les prix viennent des contrats (shared/creation.ts, shared/accounting/common.ts) : jamais en dur.",
    component: lazy(() => import("./boards/AF-Grilles")),
  },
  {
    id: "AF-Compte-Client",
    ref: "AF11",
    title: "Compte de facturation d'un client",
    area: "finance",
    path: "/finance/comptes/$companyId",
    href: "/finance/comptes/cmp_atelier_roux",
    permission: ["finance.admin", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.vue",
    space: null,
    component: lazy(() => import("./boards/AF-Compte-Client")),
  },
  {
    id: "AF-Saas-Factures",
    ref: "AF12",
    title: "Factures émises par Melrys (SaaS)",
    area: "finance",
    path: "/finance/factures",
    href: "/finance/factures",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.factures",
    space: null,
    component: lazy(() => import("./boards/AF-Saas-Factures")),
  },
  {
    id: "AF-Facturation-Cabinets",
    ref: "AF13",
    title: "Facturation mensuelle aux cabinets",
    area: "finance",
    path: "/finance/facturation-cabinets",
    href: "/finance/facturation-cabinets",
    permission: ["finance", "read"],
    persona: "admin",
    kind: "page",
    nav: "finance.cabinets",
    space: null,
    component: lazy(() => import("./boards/AF-Facturation-Cabinets")),
  },
];
